import { render, staticRenderFns } from "./MediaTypeBadge.vue?vue&type=template&id=621e371e&scoped=true"
import script from "./MediaTypeBadge.vue?vue&type=script&lang=ts"
export * from "./MediaTypeBadge.vue?vue&type=script&lang=ts"
import style0 from "./MediaTypeBadge.vue?vue&type=style&index=0&id=621e371e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621e371e",
  null
  
)

export default component.exports